import { initialPatientInformationState } from '../../patientInformation/store/patientInformation.reducers'
import { PulsaraConstants } from './pulsara.constants'
import { IPulsaraState, IPulsaraAction } from './pulsara.types'

export const initialBillingState = {
  insuranceInformation: undefined,
  relationshipsAndGuarantors: undefined,
  pcsInformation: undefined,
  authorizationInformation: undefined,
  cmsInformation: undefined,
  paymentInformation: undefined,
}

const initialPulsaraDemographics = {
  firstName: '',
  firstNamePNNV: null,
  lastName: '',
  lastNamePNNV: null,
  dOB: '',
  dOBPNNV: null,
  age: '',
  agePNNV: null,
  ageUnit: null,
  weight: '',
  weightPNNV: null,
  weightUnits: null,
  height: '',
  heightUnits: null,
  gender: null,
  genderPNNV: null,
}

const initialEmsPatient = {
  patientDemographics: undefined,
  patientImmunizations: undefined,
  patientAllergies: undefined,
  patientMedications: undefined,
  patientMedicalHistory: undefined,
  patientInformation: initialPatientInformationState,
}

const initialPulsaraDetails = {
  caseType: '',
  createdAt: '',
  patient: { patientDemographics: initialPulsaraDemographics },
  situation: { complaint: '' },
  vitals: [],
  labs: [],
  attachmentList: [],
  attachments: [],
}

const initialEmsChartsData = {
  ptid: '',
  patient: initialEmsPatient,
  situation: undefined,
  billing: undefined,
}

export const initialPulsaraState: IPulsaraState = {
  currentStep: 1,
  currentSubStep: 1,
  selectedDateRange: null,
  loading: null,
  selectedPulsaraId: null,
  selectedAttachment: null,
  pulsaraRecords: [],
  pulsaraDetails: initialPulsaraDetails,
  emsChartsData: initialEmsChartsData,
  patientSelections: {},
  importSelections: {
    ptid: null,
    patient: initialEmsPatient,
    situation: undefined,
    billing: undefined,
    selectedVitals: [],
    selectedLabs: [],
    selectedAttachments: [],
  },
  pulsaraAttachmentToDelete: null,
}

export function pulsaraReducer(state: IPulsaraState = initialPulsaraState, action: IPulsaraAction): IPulsaraState {
  switch (action.type) {
    case PulsaraConstants.SET_CURRENT_STEP:
      return { ...state, currentStep: action.currentStep || 1 }
    case PulsaraConstants.SET_CURRENT_SUB_STEP:
      return { ...state, currentSubStep: action.currentSubStep }
    case PulsaraConstants.FETCH_PULSARA_RECORDS:
      return { ...state, selectedDateRange: action.selectedDateRange }
    case PulsaraConstants.SET_LOADING:
      return { ...state, loading: action.loading }
    case PulsaraConstants.FETCH_PULSARA_DETAILS:
      return { ...state, selectedPulsaraId: action.selectedPulsaraId }
    case PulsaraConstants.FETCH_PULSARA_ATTACHMENT_IMAGE:
      return { ...state, selectedAttachment: action.selectedAttachment }
    case PulsaraConstants.SET_PULSARA_RECORDS:
      return { ...state, pulsaraRecords: action.pulsaraRecords || [] }
    case PulsaraConstants.SET_PULSARA_DETAILS:
      return { ...state, pulsaraDetails: action.pulsaraDetails }
    case PulsaraConstants.SET_PULSARA_ATTACHMENTS_LIST:
      return { ...state, pulsaraDetails: { ...state.pulsaraDetails, attachmentList: action.attachmentList } }
    case PulsaraConstants.SET_PULSARA_ATTACHMENTS:
      return { ...state, pulsaraDetails: { ...state.pulsaraDetails, attachments: action.attachments } }
    case PulsaraConstants.SET_IMPORT_SELECTIONS:
      return { ...state, importSelections: action.importSelections }
    case PulsaraConstants.SET_PATIENT_SELECTIONS:
      return { ...state, patientSelections: action.patientSelections }
    case PulsaraConstants.SET_EMS_CHARTS_DATA:
      return { ...state, emsChartsData: action.emsChartsData }
    case PulsaraConstants.SET_SELECTED_VITALS:
      return { ...state, importSelections: { ...state.importSelections, selectedVitals: action.selectedVitals } }
    case PulsaraConstants.SET_SELECTED_LABS:
      return { ...state, importSelections: { ...state.importSelections, selectedLabs: action.selectedLabs } }
    case PulsaraConstants.SET_SELECTED_ATTACHMENTS:
      return {
        ...state,
        importSelections: { ...state.importSelections, selectedAttachments: action.selectedAttachments },
      }
    case PulsaraConstants.DELETE_PULSARA_ATTACHMENT:
      return { ...state, pulsaraAttachmentToDelete: action.pulsaraAttachmentToDelete }
    case PulsaraConstants.SET_PULSARA_STATE:
      return { ...state, ...action.pulsaraState }
    case PulsaraConstants.RESET_PULSARA:
      return initialPulsaraState
    default:
      return state
  }
}
